import { createClient } from '@supabase/supabase-js';

// URL et clé de Supabase à configurer via `.env` pour plus de sécurité
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log("Supabase URL:", supabaseUrl);

// Initialisation de Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

